import React, { useState } from "react"
import trcss from "../../styles/Telerecovery.module.css"
import { Button } from "primereact/button"
import { Dialog } from "primereact/dialog"
import ExternalLinkPopup from "./ExternalLinkPopup"

export default function CallErrorPopup({ showPopup, setShowPopup }) {
    const [showExternalLinkPopup, setShowExternalLinkPopup] = useState(false)
    const link = "https://www.freecallerregistry.com/fcr"

    const footerContent = (
        <div className={trcss.buttons}>
            <Button
                className={trcss.alert_button}
                label="Undersood"
                onClick={() => setShowPopup(false)}
                autoFocus
            />
        </div>
    )

    return <Dialog
        header={
            <div style={{ color: "red", display: "flex", gap: "10px", alignItems: "center", lineHeight: "17px" }}>
                <i style={{ fontSize: "17px" }} className="pi pi-exclamation-triangle"></i>
                <span style={{ fontSize: "16px" }}>Attention</span>
            </div>
        }
        visible={showPopup}
        style={{ width: '50vw' }}
        className="custom_dialog"
        footer={footerContent}
        modal
        closable={false}
        onHide={() => setShowPopup(false)}
    >
        <ExternalLinkPopup
            link={link}
            showPopup={showExternalLinkPopup}
            setShowPopup={setShowExternalLinkPopup}
            closeFirstPopup={() => setShowPopup(false)}
        />
        <div style={{ textAlign: "left", display: "flex", flexDirection: "column", gap: "10px" }}>
            <p>Your Telerecovery number has been flagged by the participant's carrier service as "Scam Likely", "Spam", "RoboCall", or some variant based on the device or network.</p>
            <p>The FCC has established this free registry site: <span className={trcss.link} style={{ color: "#873CAA" }} onClick={(e) => {
                setShowExternalLinkPopup(true)
            }}>{link}</span>, which covers the main analytic companies that support major US wireless carriers that can remove a negative label on a number.</p>
            <p>Please head over to the "Free Caller Registry" and register your number(s) to remove the negative labels.</p>
        </div>
    </Dialog>
}